import React, { PropsWithChildren, useCallback } from "react";

import { LanguageType, useTranslation } from "@/translations";

import { LanguageContext } from "./LanguageContext.ts";

const LanguageContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { i18n } = useTranslation();

  const handleChangeLanguage = useCallback(
    (language: LanguageType) => {
      void (async () => {
        await i18n.changeLanguage(language);
      })();
    },
    [i18n]
  );

  return (
    <LanguageContext.Provider value={{ language: i18n.language as LanguageType, setLanguage: handleChangeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContextProvider;
